import WorkspaceEvaluation from "../../WorkspaceEvaluation"
import WorkspaceEvaluateResponse from "../WorkspaceEvaluateResponse"

/** The resolved entity (partial) evaluation. */
export class PartialWorkspaceEvaluateResponse implements WorkspaceEvaluateResponse {
  constructor(readonly evaluation: WorkspaceEvaluation) {}
}
